export default __webpack_public_path__ + "static/media/image_circle.058db4be.svg";